/** 锚点目标相对导航底边再留出的间距 */
export const NAV_SCROLL_GAP_PX = 50

/**
 * 滚动到页面锚点，停在固定导航下方固定间距处（与 navbar / footer 跳链共用）。
 */
export function scrollToSection(href: string): void {
  const id = href.startsWith('#') ? href.slice(1) : href
  if (!id) return

  if (id === 'top') {
    window.scrollTo({ top: 0, behavior: 'smooth' })
    return
  }

  const target = document.getElementById(id)
  if (!target) return

  const nav = document.querySelector<HTMLElement>('.nav-shell .navbar')
  const navBottom = nav?.getBoundingClientRect().bottom ?? 87
  const top =
    window.scrollY + target.getBoundingClientRect().top - navBottom - NAV_SCROLL_GAP_PX

  window.scrollTo({
    top: Math.max(0, top),
    behavior: 'smooth'
  })
}
